var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherFog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 35.3334L15.3333 32.8334L17.8333 30.3334L20.3333 32.8334L17.8333 35.3334ZM12.0833 32.8334L10.3333 31.0834L15.25 26.1667L17 27.9167L12.0833 32.8334ZM22.8333 30.3334L20.3333 27.8334L22.8333 25.3334L25.3333 27.8334L22.8333 30.3334ZM7.83333 30.3334L5.33333 27.8334L7.83333 25.3334L10.3333 27.8334L7.83333 30.3334ZM9.49999 23.6667C6.97222 23.6667 4.81249 22.7709 3.02083 20.9792C1.22916 19.1875 0.333328 17.0278 0.333328 14.5C0.333328 12.1945 1.09722 10.1806 2.62499 8.45837C4.15277 6.73615 6.04166 5.72226 8.29166 5.41671C9.18055 3.83337 10.3958 2.59032 11.9375 1.68754C13.4792 0.784763 15.1667 0.333374 17 0.333374C19.5 0.333374 21.6736 1.13199 23.5208 2.72921C25.368 4.32643 26.4861 6.31949 26.875 8.70837C28.7917 8.87504 30.4028 9.66671 31.7083 11.0834C33.0139 12.5 33.6667 14.1945 33.6667 16.1667C33.6667 18.25 32.9375 20.0209 31.4792 21.4792C30.0208 22.9375 28.25 23.6667 26.1667 23.6667H9.49999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherFog);
export default __webpack_public_path__ + "static/media/weather-fog.f3868159592e9fa7707e82cf1e07f782.svg";
export { ForwardRef as ReactComponent };